import React, { useEffect, useState } from "react";
import {
  ApiDelete,
  ApiGet,
  ApiPost,
  ApiPut,
} from "../../../helpers/API/ApiData";
import DataTable, { defaultThemes } from "react-data-table-component";
import { useHistory } from "react-router-dom";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import { Button } from "react-bootstrap";
import { getUserInfo } from "../../../utils/user.util";
import { Modal } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import List from "@material-ui/core/List";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";
import moment from "moment";
import OrganizationUser from "../Organization/OrganizationUser";

import Profile from "./Profile";
import ReactTooltip from "react-tooltip";
import CsvDownload from "react-json-to-csv";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const organigationRoleList = [
  "Assistant Director",
  "Assistant Vice President",
  "Associate Vice President",
  "Chief Executive Officer",
  "Chief Financial Officer",
  "Chief Operating Officer",
  "Co-Founder",
  "Director",
  "Executive Vice President",
  "Founder",
  "Manager",
  "Partner",
  "President",
  "Product Manager",
  "Senior Director",
  "Senior Vice President",
  "Vice President",
  "Other",
];

const Role = (props) => {
  let history = useHistory();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [roleData, setRoleData] = useState([]);
  const [dataChange, setDataChange] = useState([]);
  const [pid, setPid] = useState();
  const [updateProduct, setUpdateProduct] = useState(false);
  const [submitValue, setSubmitValue] = useState(false);
  const [initData, setInitdata] = useState();
  const [option, setOption] = useState();
  const [status, setstatus] = useState();
  const [statusid, setstatusid] = useState();
  const [data, setData] = useState({});

  const [roleName, setRoleName] = useState();
  const [description, setDescription] = useState();
  const [active, setactive] = useState(true);

  const [roleNameUpdate, setRoleNameUpdate] = useState();
  const [roleUpdate, setRoleupdate] = useState();
  const [descriptionUpdate, setDescriptionUpdate] = useState();
  const [msg, setMsg] = useState("");

  const [updateDetails, setUpdateDetails] = useState(false);

  const [donationCsvAdmin, setDonationCsvAdmin] = useState([]);
  const [dataCSVAdmin, setDataCSVAdmin] = useState([]);
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);
  const [Persondata, setPersondata] = useState();

  // const [errors] = useState([]);
  const [userReport, setUserReport] = useState();
  const [filteredReport, setFilteredReport] = useState();
  const [UserEmail, setUserEmail] = useState();
  const [errors, setErrors] = useState({});
  let userInfo = getUserInfo();
  // console.log(userInfo.user.id);
  const [show, setShow] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    setSubmitValue(false);
    setUpdateProduct(true);
  };

  const handleClose1 = () => {
    setOpen(false);
    setErrors({});
  };

  const [profile, setProfile] = useState(false);

  const handleProfileClose = () => {
    setProfile(false);
    setErrors({});
  };

  const handleClose = () => {
    setShow(false);
    setErrors({});
  };

  const handleShow = (id) => {
    setShow(true);
    setPid(id);
  };

  useEffect(() => {
    rolegetApi();
  }, [dataChange]);

  useEffect(() => {
    if (donationCsvAdmin) {
      donationCsvAdmin.map((donation) => {
        let data = {
          Email: donation?.email,
          Name: donation?.name,
          Date: moment(donation?.createdAt).utc().format("MMM Do YYYY, h:mm a"),
          Role: donation?.currentRole,
          LastModified: moment(donation?.updatedAt)
            .utc()
            .local()
            .format("MMM Do YYYY, h:mm a"),
          Status:
            donation?.status == true
              ? "Active"
                ? donation?.status == false
                : "Deactive"
              : "",
          // FirstName: donation?.firstName,
          // LastName: donation?.lastName,
          // DonationAmount: donation?.amount,
          // ArtistName: donation?.artistId.artistName,
          // RealName: donation?.artistId.realName,
          // Country: donation?.country,
          // DonationDate: donation?.created,
        };
        setDataCSVAdmin((currVal) => [...currVal, data]);
      });
    }
    console.log("UsertCsvReport", donationCsvAdmin);
  }, [donationCsvAdmin]);

  const rolegetApi = async () => {
    setIsLoaderVisible(true);
    await ApiGet("user/all-admin-organization")
      .then((res) => {
        setRoleData(res.data.payload?.users);
        setDonationCsvAdmin(res.data.payload.users);
        setFilteredReport(res.data.payload?.users);
        setUserReport(res.data.payload?.users);
        console.log("roleadd", res.data);
        setIsLoaderVisible(false);
      })
      .catch((error) => {
        toast.error(error.message);
        setIsLoaderVisible(false);
      });
  };

  const handleDeleteManagerInfo = async () => {
    await ApiDelete(`role/id=${pid}`)
      .then((res) => {
        setDataChange([...dataChange, "Payment delete"]);
        window.location.reload();
      })
      .catch((err) => {
        console.log("err");
      });
  };

  const handleForUpdateManager = async (id) => {
    setOpen(true);
    setPid(id);
    setSubmitValue(true);
    let temp = roleData.filter((data) => {
      return data._id === id;
    });
    setRoleNameUpdate(temp[0].roleName);
    setDescriptionUpdate(temp[0].description);
  };

  const handelUpdateDetails = async () => {
    if (!formUpdateValidator()) {
      console.log("ERROR PUT", errors);
      return;
    }

    setLoading(true);

    let data = {
      name: roleNameUpdate,
      phone: descriptionUpdate,
      email: UserEmail,
      currentRole: roleUpdate,
    };

    await ApiPut(`user`, data)
      .then((res) => {
        console.log("dd", res.data.payload.updateByAdmin);
        setData(res.data.payload.updateByAdmin);
        setOpen(false);
        setErrors({});
        setUpdateProduct(false);
        setDataChange([...dataChange, "Role Updated"]);
        setLoading(false);
        toast.success("User updated successfully");

        // toast.success("Role Updated Successfully");
        // console.log(res);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handlealtermessage = (id, status) => {
    setShow(true);
    setstatus(status);
    setstatusid(id);
  };

  const [profileData, setProfileData] = useState();

  const ProfileFuntions = (data) => {
    console.log("DataLeader-Bridge", data);
    if (data && data) {
      setProfileData(data);
      setProfile(true);
    }
  };

  const handelUpdatestatusDetails = async () => {
    setLoading(true);
    await ApiPut(`user/update-status/id=${statusid}&status=${status}`)
      .then((res) => {
        setOpen(false);
        setErrors({});
        setUpdateProduct(false);
        setDataChange([...dataChange, "Role Updated"]);
        setLoading(false);
        setShow(false);
        toast.success(
          `${
            res.data.payload.updateUser.status == true ? "Active" : "Deactive"
          }d`
        );

        // toast.success("Role Updated Successfully");
        // console.log(res);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  };

  let i = 0;
  const columns = [
    {
      name: "S.No.",
      cell: (row, index) => index + 1,
      width: "5%",
    },
    {
      name: "Date",
      selector: "createdAt",
      cell: (row) => {
        // let d = new Date(row.createdAt);
        // let month = [
        //   "Jan",
        //   "Feb",
        //   "Mar",
        //   "Apr",
        //   "May",
        //   "Jun",
        //   "Jul",
        //   "Aug",
        //   "Sep",
        //   "Oct",
        //   "Nov",
        //   "Dec",
        // ];
        // let updatedate = ` ${
        //   month[d.getMonth()]
        // } ${d.getDate()},${d.getFullYear()} `;
        // return <div>{updatedate}</div>;
        return (
          <div>{moment(row.createdAt).utc().format("MMM Do YYYY, h:mm a")}</div>
        );
      },
      width: "210px",
      sortable: true,
    },
    {
      name: "Full Name",
      selector: "fname",
      width: "140px",
      sortable: true,
    },
    {
      name: "Email",
      selector: "email",
      width: "300px",
      sortable: true,
    },
    // {
    //   name: "Role",
    //   selector: "currentRole",
    //   width: "200px",
    //   sortable: true,
    // },

    {
      name: "User Count",
      cell: (row) => {
        return (
          <>
            <div>{row?.user?.length}</div>
          </>
        );
      },
      selector: (row) => row.lastLogin,
      width: "160px",

      sortable: true,
    },

    {
      name: "Last Modified",
      cell: (row) => {
        return (
          <>
            <div>
              {moment(row.updatedAt)
                .utc()
                .local()
                .format("MMM Do YYYY, h:mm a")}
            </div>
          </>
        );
      },
      selector: (row) => row.lastLogin,
      width: "210px",
      sortable: true,
    },

    {
      name: "Status",
      cell: (row) => {
        return (
          <>
            {row?.status == false && "Deactive"}

            {row?.status == true && "Active"}
          </>
        );
      },
      selector: (row) => row.status,
      sortable: true,
      width: "120px",
    },

    {
      name: "Organization Code",
      cell: (row) => {
        console.log("row@@@@@@", row);
        return <>{row.OrgRanDomID}</>;
      },
      selector: (row) => row.OrgRanDomID,
      width: "160px",
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => {
        return (
          <>
            <div className="d-flex justify-content-between">
              <div className="d-flex align-items-center">
                <ReactTooltip id="registerTip" place="top" effect="solid">
                  Organization User
                </ReactTooltip>
                <h4
                  style={{ cursor: "pointer" }}
                  className="mb-0 mt-3 mr-4"
                  onClick={() => ProfileFuntions(row)}
                >
                  <i data-tip data-for="registerTip" class="fas fa-user"></i>
                </h4>
                <div
                  className="cursor-pointer mr-0 mt-3"
                  onClick={() => {
                    setUpdateProduct(false);
                    setUpdateDetails(true);
                    handleForUpdateManager(row._id);
                    setDescriptionUpdate(row.phone);
                    setRoleNameUpdate(row.fname);
                    setUserEmail(row.email);
                    setRoleupdate(row.currentRole);
                  }}
                >
                  <CreateIcon />
                </div>
              </div>

              {row.status == false && (
                <div className="cursor-pointer ml-5 mt-1">
                  <button
                    onClick={() => {
                      handlealtermessage(row._id, true);
                    }}
                    className="btn btn-success"
                  >
                    <span
                      style={{
                        border: "none",
                        display: "flex",
                        whiteSpace: "nowrap",
                        // height: "35px",
                        // paddingLeft: "21px",
                        // paddingRight: "21px",
                      }}
                    >
                      Active
                    </span>
                  </button>
                </div>
              )}

              {row.status == true && (
                <div className="cursor-pointer ml-5 mt-1">
                  <button
                    className="btn-danger btn"
                    onClick={() => {
                      handlealtermessage(row._id, false);
                    }}
                    style={{
                      border: "none",
                      display: "flex",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Deactive
                  </button>
                </div>
              )}
            </div>
          </>
        );
      },
      wrap: true,
      width: "210px",
      sortable: true,
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: defaultThemes.default.divider.default,
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
  };

  const [createrData, setCreaterdata] = useState({});

  const handleChange = (e) => {
    let { name, value } = e.target;

    setCreaterdata((prevState) => ({
      ...prevState,

      [name]: value,
    }));

    setErrors({ ...errors, [name]: "" });
  };

  console.log("createrData", createrData);
  const formValidator = () => {
    let isValid = true;

    if (!createrData.organizationName) {
      setErrors((cv) => {
        return { ...cv, organizationName: "Please Enter organization Name" };
      });
      isValid = false;
    }

    if (createrData && !createrData.Contactemail) {
      setErrors((cv) => {
        return { ...cv, Contactemail: "Please Enter email" };
      });
      isValid = false;
    } else if (
      createrData.Contactemail &&
      !createrData.Contactemail.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      setErrors((cv) => {
        return { ...cv, Contactemail: "Please Enter valid email" };
      });
      isValid = false;
    }

    if (!createrData.Contactemail) {
      setErrors((cv) => {
        return { ...cv, Contactemail: "Please Enter email" };
      });
      isValid = false;
    }

    if (!createrData.program_type) {
      setErrors((cv) => {
        return { ...cv, program_type: "Please Enter program type" };
      });
      isValid = false;
    }

    if (!createrData.ProgramName) {
      setErrors((cv) => {
        return { ...cv, ProgramName: "Please Enter Program Name" };
      });
      isValid = false;
    }

    if (!createrData.OrganizationWebsiteAddress) {
      setErrors((cv) => {
        return {
          ...cv,
          OrganizationWebsiteAddress:
            "Please Enter Organization Website Address",
        };
      });
      isValid = false;
    }

    if (!createrData.ProgramWebsiteAddress) {
      setErrors((cv) => {
        return {
          ...cv,
          ProgramWebsiteAddress: "Please Enter Program Website Address",
        };
      });
      isValid = false;
    }

    if (!createrData.ContactFirstName) {
      setErrors((cv) => {
        return { ...cv, ContactFirstName: "Please Enter Contact First Name" };
      });
      isValid = false;
    }

    if (!createrData.ContactLastName) {
      setErrors((cv) => {
        return { ...cv, ContactLastName: "Please Enter Contact Last Name*" };
      });
      isValid = false;
    }

    if (!createrData.Contactemail?.trim()) {
      setErrors((cv) => {
        return { ...cv, Contactemail: "* Please enter Contact email" };
      });
      isValid = false;
    } else if (
      createrData.Contactemail?.trim() &&
      !createrData.Contactemail.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      setErrors((cv) => {
        return { ...cv, Contactemail: "* Please enter valid Contact email" };
      });
      isValid = false;
    }

    if (!createrData.ContactPhone) {
      setErrors((cv) => {
        return { ...cv, ContactPhone: "Please Enter Contact Phone*" };
      });
      isValid = false;
    }

    if (!createrData?.contact_phone_code) {
      setErrors((cv) => {
        return {
          ...cv,
          contact_phone_code: "Please enter country code and contact number*",
        };
      });
      isValid = false;
    }

    return isValid;
  };

  const formUpdateValidator = () => {
    let isValid = true;

    if (!roleNameUpdate) {
      setErrors((cv) => {
        return { ...cv, name: "Please Enter  Name" };
      });
      isValid = false;
    }

    // if (!descriptionUpdate) {
    //   setErrors((cv) => {
    //     return { ...cv, phone: "Please Enter phonenumber" };
    //   });
    //   isValid = false;
    // }

    return isValid;
  };

  const submitDetails = async () => {
    if (!formValidator()) {
      console.log("ERROR POST", errors);
      return;
    }

    setLoading(true);

    const Body = {
      email: createrData.Contactemail,
      phone: createrData?.contact_phone_code + " " + createrData.ContactPhone,
      fname: createrData.ContactFirstName,
      lname: createrData.ContactLastName,
      organizationName: createrData.organizationName,
      currentRole: "organization",
      organizationEmail: createrData.Contactemail,
      organizationWebsite: createrData.OrganizationWebsiteAddress,
      programName: createrData.ProgramName,
      programType: createrData.program_type,
      permission: true,
    };

    await ApiPost(`user/organization-signup`, Body)
      .then(async (res) => {
        if (res.data && res.data.payload && res.data.payload) {
          setUpdateProduct(false);
          setLoading(false);
          setDataChange([...dataChange, "Details Added"]);
          setRoleName();
          setDescription();
          setCreaterdata({});
          setOpen(false);
          toast.success(res.data.message);
        } else {
          setMsg(res.data.message);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.message);
      });
  };

  const handleSearch = (e) => {
    console.log("eeeee", e.target.value);
    var value = e.target.value.toLowerCase();
    setFilteredReport(() =>
      userReport.filter(
        (item) =>
          item?.name?.toLowerCase().includes(value) ||
          item?.email?.toLowerCase().includes(value) ||
          item?.OrgRanDomID.includes(value)
        // item?.phone?.toLowerCase().includes(value)
      )
    );
  };

  const getAlloption = async () => {
    await ApiGet(`option/get-all`)
      .then(async (res) => {
        if (res.data && res.data.payload && res.data.payload) {
          setOption(res.data.payload.option);
        }
      })
      .catch((error) => {
        setMsg(error.message);
      });
  };

  useEffect(() => {
    getAlloption();
  }, []);

  return (
    <>
      <div>
        {/* <div className="card p-1">
          <div className="p-2 mb-2">
            <div class="p-2 d-flex bd-highlight">
              <div class="flex-grow-1 bd-highlight">
                <div className="pl-2 pt-2 headerTitle">User Reports</div>
              </div>
              <div class="bd-highlight col-4">
                <input
                  type="text"
                  className={`form-control form-control-lg form-control-solid `}
                  name="title"
                  placeholder="Search user"
                  onChange={(e) => handleSearch(e)}
                />
              </div>
              <div class="bd-highlight">
                <button
                  className="btn btnColor"
                  onClick={() => {
                    setUpdateDetails(false);
                    handleClickOpen();
                  }}
                >
                  Add User
                </button>
              </div>
            </div>

            
          </div>
        </div> */}

        <div className="card p-1">
          <div className="p-2 mb-2">
            <div className="row mb-4 pr-3">
              <div className="col d-flex justify-content-between">
                <h2 className="pl-3 pt-2">Organization Management</h2>
              </div>
              <div className="col">
                <div>
                  <input
                    type="text"
                    className={`form-control form-control-lg form-control-solid `}
                    name="title"
                    placeholder="Search Organization"
                    onChange={(e) => handleSearch(e)}
                  />
                </div>
              </div>
              <div className="cus-medium-button-style button-height">
                <button
                  className="btn btnColor"
                  onClick={() => {
                    setUpdateDetails(false);
                    handleClickOpen();
                  }}
                >
                  Add Organization
                </button>

                <CsvDownload
                  className={``}
                  data={dataCSVAdmin}
                  filename="organizations.csv"
                  style={{
                    //pass other props, like styles
                    backgroundColor: "#F64E60",
                    borderRadius: "6px",
                    border: "1px solid #fff",
                    display: "inline-block",
                    cursor: "pointer",
                    color: "#FFFFFF",
                    fontSize: "12px",
                    padding: "10px 18px",
                    textDecoration: "none",
                    position: "right",
                  }}
                >
                  Export to Csv
                </CsvDownload>
              </div>
            </div>
          </div>
          <DataTable
            columns={columns}
            data={filteredReport}
            pagination
            customStyles={customStyles}
            style={{
              marginTop: "-3rem",
            }}
            progressPending={isLoaderVisible}
            progressComponent={
              <Loader type="Puff" color="#334D52" height={30} width={30} />
            }
          />
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="text-danger">Alert!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to {status == true ? "Active" : "Deactive"} this
          User?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            cancel
          </Button>
          <Button variant="danger" onClick={() => handelUpdatestatusDetails()}>
            {status == true && !loading ? "Active" : "Deactive"}
            {loading && <span className="mx-3 spinner spinner-white"></span>}
          </Button>
        </Modal.Footer>
      </Modal>

      <Dialog
        fullScreen
        open={open}
        onClose={handleClose1}
        TransitionComponent={Transition}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose1}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>

        <List>
          {updateProduct && updateProduct === true ? (
            <div className="form ml-30 ">
              {/* Account Number */}
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">
                  Institution Name *
                </label>
                <div className="col-lg-9 col-xl-6">
                  <div>
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder="Organization Name"
                      className={`form-control form-control-lg form-control-solid `}
                      name="organizationName"
                      value={createrData.organizationName}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["organizationName"]}
                  </span>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">
                  Institution Website Address *
                </label>
                <div className="col-lg-9 col-xl-6">
                  <div>
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder="Organization Website Address"
                      className={`form-control form-control-lg form-control-solid `}
                      name="OrganizationWebsiteAddress"
                      value={createrData?.OrganizationWebsiteAddress}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["OrganizationWebsiteAddress"]}
                  </span>
                </div>
              </div>
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">
                  Program Type *
                </label>
                <div className="col-lg-9 col-xl-6">
                  <div>
                    <select
                      name="program_type"
                      className={`form-control form-control-lg form-control-solid `}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    >
                      <option value={null}>Select</option>
                      {option?.map((data) => (
                        <>
                          <option value={data._id}>{data.name}</option>
                        </>
                      ))}
                    </select>
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["program_type"]}
                  </span>
                </div>
              </div>

              {/* <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">
                  Phone number
                </label>
                <div className="col-lg-9 col-xl-6">
                  <div>
                    <input
                      type="number"
                      autoComplete="off"
                      placeholder="Phone Number"
                      className={`form-control form-control-lg form-control-solid `}
                      name="phone"

                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["phone"]}
                  </span>
                </div>
              </div> */}

              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">
                  Program Name*
                </label>
                <div className="col-lg-9 col-xl-6">
                  <div>
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder="Program Name"
                      className={`form-control form-control-lg form-control-solid `}
                      name="ProgramName"
                      value={createrData?.ProgramName}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["ProgramName"]}
                  </span>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">
                  Program Website Address*
                </label>
                <div className="col-lg-9 col-xl-6">
                  <div>
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder="Program Website Address"
                      className={`form-control form-control-lg form-control-solid `}
                      name="ProgramWebsiteAddress"
                      value={createrData.ProgramWebsiteAddress}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["ProgramWebsiteAddress"]}
                  </span>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">
                  Contact First Name*
                </label>
                <div className="col-lg-9 col-xl-6">
                  <div>
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder="Contact First Name"
                      className={`form-control form-control-lg form-control-solid `}
                      name="ContactFirstName"
                      value={createrData.ContactFirstName}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["ContactFirstName"]}
                  </span>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">
                  Contact Last Name*
                </label>
                <div className="col-lg-9 col-xl-6">
                  <div>
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder="Contact Last Name"
                      className={`form-control form-control-lg form-control-solid `}
                      name="ContactLastName"
                      value={createrData.ContactLastName}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["ContactLastName"]}
                  </span>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">
                  Contact email*
                </label>
                <div className="col-lg-9 col-xl-6">
                  <div>
                    <input
                      type="email"
                      autoComplete="off"
                      placeholder="Contact email"
                      className={`form-control form-control-lg form-control-solid `}
                      name="Contactemail"
                      value={createrData.Contactemail}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["Contactemail"]}
                  </span>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">
                  Contact Phone*
                </label>
                <div className="col-lg-3 col-xl-1 pr-0">
                  <div>
                    <input
                      className={`form-control form-control-lg form-control-solid `}
                      type="text"
                      name="contact_phone_code"
                      placeholder="+1"
                      pattern="[0-9]*"
                      maxLength={5}
                      value={createrData?.contact_phone_code}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      // defaultValue="+44"
                      // onKeyDown={(e) => handleData(e)}
                      // placeholder="John Doe"
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["contact_phone_code"]}
                  </span>
                </div>
                <div className="col-lg-6 col-xl-5 p-0">
                  <div>
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder="Contact Phone"
                      className={`form-control form-control-lg form-control-solid `}
                      name="ContactPhone"
                      value={createrData?.ContactPhone}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["ContactPhone"]}
                  </span>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-center">
                <button
                  onClick={(e) => {
                    e.preventDefault();

                    !loading && submitDetails(e);
                  }}
                  className="btn btnColor mr-2"
                >
                  <span>Submit Details</span>
                  {loading && (
                    <span className="mx-3 spinner spinner-white"></span>
                  )}
                </button>
              </div>
            </div>
          ) : null}
        </List>
        <List>
          {updateDetails && updateDetails === true ? (
            <div className="form ml-30 ">
              {/* First Name */}
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">
                  Full name
                </label>
                <div className="col-lg-9 col-xl-6">
                  <div>
                    <input
                      type="text"
                      className={`form-control form-control-lg form-control-solid `}
                      name="name"
                      value={roleNameUpdate}
                      onChange={(e) => {
                        setRoleNameUpdate(e.target.value);
                        setErrors((cv) => {
                          return { ...cv, roleNameUpdate: "" };
                        });
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["name"]}
                  </span>
                </div>
              </div>
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">
                  Current Role
                </label>
                <div className="col-lg-9 col-xl-6">
                  <div>
                    <select
                      name="currentRole"
                      className={`form-control form-control-lg form-control-solid `}
                      onChange={(e) => {
                        setRoleupdate(e.target.value);
                        setErrors((cv) => {
                          return { ...cv, roleUpdate: "" };
                        });
                      }}
                    >
                      <option value={roleUpdate}>
                        {roleUpdate ? roleUpdate : "Select Organization Role"}
                      </option>
                      {organigationRoleList.map((item, index) => {
                        return <option value={item}>{item}</option>;
                      })}
                    </select>
                    {/* <span style={{ color: "red" }}>
                      {verificationError["currentRole"]}
                    </span> */}
                    {/* <input
                      type="text"
                      className={`form-control form-control-lg form-control-solid `}
                      name="name"
                      value={roleUpdate}
                      onChange={(e) => {
                        setRoleupdate(e.target.value);
                        setErrors((cv) => {
                          return { ...cv, roleUpdate: "" };
                        });
                      }}
                    /> */}
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["name"]}
                  </span>
                </div>
              </div>
              {/* swift code */}
              {/* <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">
                  phone
                </label>
                <div className="col-lg-9 col-xl-6">
                  <div>
                    <input
                      type="number"

                      min="10"
                      className={`form-control form-control-lg form-control-solid `}
                      name="phone"
                      value={descriptionUpdate}
                      onChange={(e) => {
                        setDescriptionUpdate(e.target.value);
                        setErrors((cv) => {
                          return { ...cv, descriptionUpdate: "" }
                        })
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["phone"]}
                  </span>
                </div>
              </div> */}

              <div className="d-flex align-items-center justify-content-center">
                {submitValue && submitValue === true ? (
                  <button
                    onClick={(e) => {
                      handelUpdateDetails();
                    }}
                    className="btn btn-success mr-2"
                  >
                    <span>Update Details</span>
                    {loading && (
                      <span className="mx-3 spinner spinner-white"></span>
                    )}
                  </button>
                ) : (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      submitDetails(e);
                    }}
                    className="btn btn-success mr-2"
                  >
                    <span>Submit Details</span>
                    {loading && (
                      <span className="mx-3 spinner spinner-white"></span>
                    )}
                  </button>
                )}
              </div>
            </div>
          ) : null}
        </List>
      </Dialog>

      {/* user Profile  */}

      {/* user Profile end */}

      <Dialog
        fullScreen
        open={profile}
        onClose={handleProfileClose}
        TransitionComponent={Transition}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleProfileClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>

        <List>
          <OrganizationUser profile={profileData} />
        </List>
      </Dialog>
    </>
  );
};

export default Role;
